var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.25 11.25C33.9917 11.25 35.4167 12.675 35.4167 14.4166L35.4008 14.5433L35.4167 14.5591V17.5833C35.4167 17.995 35.3375 18.375 35.195 18.7391L30.4133 29.9016C29.9383 31.0416 28.8142 31.8333 27.5 31.8333H13.25C11.5083 31.8333 10.0833 30.4083 10.0833 28.6666V12.8333C10.0833 11.9625 10.4317 11.1708 11.0175 10.6008L21.4358 0.166626L23.1142 1.82913C23.5417 2.25663 23.8108 2.85829 23.8108 3.50746L23.7633 4.01413L22.2592 11.25H32.25ZM6.91668 31.8333H0.583344V12.8333H6.91668V31.8333Z",
    fill: "current",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbs);
export default __webpack_public_path__ + "static/media/thumbs.418a7c64.svg";
export { ForwardRef as ReactComponent };